import React, { forwardRef, useImperativeHandle } from 'react';
import { ProTablePlusForm } from '@mpc/common/src/components';
import { useControllableValue } from 'ahooks';
import CopyableNode from '#components/CopyableNode';

interface IProps {
  value?: any;
  onChange?: (value: any) => void;
  view?: boolean;
}

const ContactTable: React.FC<IProps> = forwardRef((props, ref) => {
  const { view } = props;
  const tableRef = React.useRef<any>();
  const [value, setValue] = useControllableValue<any>(props, {
    defaultValue: {}
  });

  useImperativeHandle(ref, () => ({
    validateFields: async () => {
      try {
        if (tableRef.current?.validate) {
          const values = await tableRef.current?.validate?.();
          if (values?.[0]?.message) {
            return Promise.reject(values?.[0]?.message)
          }
        }
        return Promise.resolve()
      } catch (error) {
        console.log(error, 'error');
        return Promise.reject()
      }
    }
  }))

  const columns = [
    {
      title: '姓名',
      dataIndex: 'contract_contact_name',
      width: 160,
      editRender: ({ index, row, value }) => {
        return {
          name: "input",
          editable: !view,
          props: {
            maxLength: 200,
          }
        }
      },
      render: (v, r) => v || '--',
    },
    {
      title: '邮箱',
      dataIndex: 'contract_contact_email',
      width: 280,
      editRender: ({ index, row, value }) => {
        return {
          name: "input",
          editable: !view,
          rule: [
            {
              pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: '请输入正确的邮箱',
            }
          ],
          props: {
            maxLength: 200,
          },
        }
      },
      render: (v, r) => v ? <CopyableNode value={v}>{v}</CopyableNode> : '--',
    },
    {
      title: '电话',
      dataIndex: 'contract_contact_phone',
      width: 200,
      editRender: ({ index, row, value }) => {
        return {
          name: "input",
          editable: !view,
          props: {
            maxLength: 200,
          }
        }
      },
      render: (v, r) => v ? <CopyableNode value={v}>{v}</CopyableNode> : '--',
    },
    {
      title: '联系地址',
      dataIndex: 'contract_contact_address',
      width: 400,
      editRender: ({ index, row, value }) => {
        return {
          name: "input",
          editable: !view,
          props: {
            maxLength: 200,
          }
        }
      },
      render: (v, r) => v || '--',
    },
  ];

  if (view && !value) {
    return <>--</>
  }

  return (
    <div style={{ width: '100%' }}>
      <ProTablePlusForm
        ref={tableRef}
        style={{ width: '100%' }}
        scroll={{ 'x': 'max-content' }}
        value={[value || {}]}
        onChange={(v) => v?.[0] && setValue(v[0])}
        columns={columns}
      />
    </div>
  )
})

export default ContactTable;
